const initialState = {
  studentTrackerColumnName: '',
};

export default initialState;
